export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=a2c07db2"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/index.vue?vue&type=template&id=a2c07db2
// module id = 1964
// module chunks = 31